import { render, staticRenderFns } from "./certAgreement.vue?vue&type=template&id=583df60c&scoped=true"
import script from "./certAgreement.vue?vue&type=script&lang=js"
export * from "./certAgreement.vue?vue&type=script&lang=js"
import style0 from "./certAgreement.vue?vue&type=style&index=0&id=583df60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583df60c",
  null
  
)

export default component.exports